import React from "react";
import { Helmet } from "react-helmet";
import { customSettings } from "./customConfig";

const PageTitle = ({ name }) => {
  return (
    <Helmet>
      <title> {`${customSettings.appName} - ${name}`} </title>
    </Helmet>
  );
};

export default PageTitle;
